module.exports = __webpack_public_path__ + "static/img/10.69a7bc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/10.jpg
// module id = 4qY5
// module chunks = 1